import axios from 'axios';

import { isExternalServiceRequest } from '@shared/api/axios-extensions/isExternalServiceRequest';
import { HttpStatusCodes } from '@shared/constants/httpStatusCodes';
import { ensureCookiesEnabledOrRedirect } from '@shared/util/cookies';
import { ProblemDetailsConverter } from '@shared/util/problemDetailsConverter';
import { reportError } from '@shared/util/sentry';
import { dropUser, refreshAnyWay } from '@shared/util/user';

let refreshTokenPromise: Promise<any> | null = null;

export const axiosErrorHandler = async (e: any): Promise<any> => {
  const originalRequest = e.config;

  if (e?.response?.status === HttpStatusCodes.Unauthorized && !isExternalServiceRequest(originalRequest)) {
    // If cookies are disabled mid-session, redirect to not-supported
    ensureCookiesEnabledOrRedirect();

    if (originalRequest._retry) {
      dropUser();
      throw e;
    }

    originalRequest._retry = true;

    if (!refreshTokenPromise) {
      refreshTokenPromise = refreshAnyWay().finally(() => {
        refreshTokenPromise = null;
      });
    }

    try {
      const result = await refreshTokenPromise;

      if (result === 'logout required') {
        dropUser();
        throw e;
      }

      return axios(originalRequest);
    } catch (refreshError) {
      reportError(refreshError);
      dropUser();
      throw e;
    }
  }

  e.error = ProblemDetailsConverter.convertApiExceptionToError(e);
  throw e;
};
